import React from 'react';

import { FormField } from '@gogame/form';
import { number } from '@gogame/schemas';

import {
  getOptionValueNumber,
  getOptionLabelNumber,
  getOptionValueInteger,
  getOptionLabelInteger,
  getOptionIdentity,
} from 'scenes/Integrations/utils';

import {
  TYPE_STRING,
  TYPE_INTEGER,
  TYPE_NUMBER,
  TYPE_BOOLEAN,
  TYPE_ARRAY,
} from './constants';

const validationInteger =
  ({ label }) =>
  async (value) => {
    try {
      await number(`${label} must be an integer`).validate(value);
    } catch (e) {
      return e.message;
    }
  };

const FieldByType = ({ type, items, ...props }) => {
  if (type === TYPE_STRING) {
    return <FormField.TextField {...props} />;
  }

  if (type === TYPE_INTEGER) {
    return (
      <FormField.TextField
        type={'number'}
        validate={validationInteger(props)}
        {...props}
      />
    );
  }

  if (type === TYPE_NUMBER) {
    return <FormField.TextField type={'number'} {...props} />;
  }

  if (type === TYPE_BOOLEAN) {
    return <FormField.Checkbox {...props} />;
  }

  if (type === TYPE_ARRAY) {
    const itemTypeIsNumber = items.type === TYPE_NUMBER;
    const itemTypeIsInteger = items.type === TYPE_INTEGER;

    return (
      <FormField.ChipsInput
        freeSolo={true}
        autoSelect={true}
        plainValue={true}
        getOptionValue={
          itemTypeIsNumber
            ? getOptionValueNumber
            : itemTypeIsInteger
              ? getOptionValueInteger
              : getOptionIdentity
        }
        getOptionLabel={
          itemTypeIsNumber
            ? getOptionLabelNumber
            : itemTypeIsInteger
              ? getOptionLabelInteger
              : getOptionIdentity
        }
        createOption={getOptionIdentity}
        {...props}
      />
    );
  }

  return null;
};

export default FieldByType;
